import script from "./UploadMultiple.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadMultiple.vue?vue&type=script&setup=true&lang=js"

import "./UploadMultiple.vue?vue&type=style&index=0&id=a535d8ae&scoped=true&lang=css"

import exportComponent from "D:\\obj\\komanch\\web-company\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a535d8ae"]])

export default __exports__